/**
 * Live region persistente da sessão da plataforma (#430).
 * Montada no Shell vazia; sobrevive à limpeza do estado da faixa.
 */
import { useEffect, useState } from 'react'
import { onImpersonationAnnounce } from '../../lib/impersonation-a11y.js'

export function ImpersonationAnnouncer() {
  const [message, setMessage] = useState('')

  useEffect(() => onImpersonationAnnounce(setMessage), [])

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
      data-testid="impersonation-live"
    >
      {message}
    </div>
  )
}
